import { FreightHeader } from './freight.models';
import { LadingType } from './types/lading-type.enum';

export const TECHNOGYM_CONTACT_UUIDS = [
  'b0c472a0-e85a-439a-9dbc-2ae40304a9f5',
  'e5e46eb9-ce9b-43e0-97fc-5aaf1a025aba'
];

export interface LadingTypeConfig {
  /** Human-readable label */
  label: string;
  /**
   * If non-null, name of the array in the API response
   * from which to pull delivery requirements.
   * Returning null yields no requirements card.
   */
  requirementsSource: ((header: FreightHeader) => string | null) | string | null;
  /**
   * Whether multi-product-per-package mode is allowed.
   * Can be a boolean or a function of the header.
   */
  multiProductPackaging: ((header: FreightHeader) => boolean) | boolean;
  /**
   * Whether requirements may be edited (Add Product button).
   */
  deliveryRequirementsEditable:
    | ((header: FreightHeader) => boolean)
    | boolean;
}

/**
 * Configuration per LadingType.
 * - Type 15: Inbound (no multi-product, no reqs)
 * - Type 16: Outbound (TG accounts get single-product, reqs editable)
 * - Type 17: Special outbound – always multi-product, no reqs
 */
export const LADING_TYPE_CONFIG: Record<LadingType, LadingTypeConfig> = {
  [LadingType.LT15]: {
    label: 'Inbound',
    requirementsSource: null,
    multiProductPackaging: false,
    deliveryRequirementsEditable: false
  },
  [LadingType.LT16]: {
    label: 'Outbound',
    requirementsSource: (header: FreightHeader) =>
      header.customer_contact_uuid != null &&
      TECHNOGYM_CONTACT_UUIDS.includes(header.customer_contact_uuid)
        ? 'tg_delivery_reqs'
        : null,
    multiProductPackaging: (header: FreightHeader) =>
      !(
        header.customer_contact_uuid != null &&
        TECHNOGYM_CONTACT_UUIDS.includes(header.customer_contact_uuid)
      ),
    deliveryRequirementsEditable: (header: FreightHeader) =>
      header.customer_contact_uuid != null &&
      TECHNOGYM_CONTACT_UUIDS.includes(header.customer_contact_uuid)
  },
  [LadingType.LT17]: {
    label: 'Type 17',
    requirementsSource: null,
    multiProductPackaging: true,
    deliveryRequirementsEditable: false
  }
  // future types...
};
